module.exports = "pages:\n- 'HowTo nmNetwork制御': ./tips/so_for_network.md\n# - '[検証]testbed-vpn経由からのFrontal API コール': ./tips/testing_frontal_API_call.md"